import React, { useState } from "react";

import {
  useSelector,
} from "react-redux";

import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  useCart,
} from "../../components/CartContext";

import "./css/Header.css";


function Header() {

  // =====================================================
  // URL PARAMETERS
  // =====================================================

  const {
    restaurantId,
    tableId,
  } = useParams();


  // =====================================================
  // ROUTER
  // =====================================================

  const navigate = useNavigate();

  const location = useLocation();


  // =====================================================
  // CART
  // =====================================================

  const {
    cartCount,
  } = useCart();


  // =====================================================
  // RESTAURANT
  // =====================================================

  const {
    restaurantName,
  } = useSelector(
    (state) => state.menu
  );


  // =====================================================
  // MOBILE MENU
  // =====================================================

  const [
    menuOpen,
    setMenuOpen,
  ] = useState(false);


  // =====================================================
  // HOME PATH
  // =====================================================

  const homePath =
    `/${restaurantId}/table/${tableId}`;


  // =====================================================
  // CLOSE MOBILE MENU
  // =====================================================

  const closeMenu = () => {

    setMenuOpen(false);

  };


  // =====================================================
  // HOME
  // =====================================================

  const goHome = () => {

    closeMenu();


    if (
      location.pathname === homePath
    ) {

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      return;

    }


    navigate(homePath);

  };


  // =====================================================
  // CART
  // =====================================================

  const goCart = () => {

    closeMenu();


    navigate(
      `${homePath}/cart`
    );

  };


  // =====================================================
  // SECTION NAVIGATION
  // =====================================================

  const navigateToSection = (
    sectionId
  ) => {

    const isHomePage =
      location.pathname === homePath;


    // -----------------------------------------------
    // ALREADY ON HOME PAGE
    // -----------------------------------------------

    if (isHomePage) {

      const section =
        document.getElementById(
          sectionId
        );


      if (section) {

        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      }


      closeMenu();

      return;

    }


    // -----------------------------------------------
    // FROM ANOTHER SCREEN
    // -----------------------------------------------

    closeMenu();


    navigate(
      `${homePath}#${sectionId}`
    );

  };


  return (

    <header className="theme3-header">

      <div className="theme3-header-inner">


        {/* =================================================
            LOGO
        ================================================= */}

        <button
          type="button"
          className="theme3-logo"
          onClick={goHome}
          aria-label={
            restaurantName
              ? `${restaurantName} Home`
              : "Spice Fusion Home"
          }
        >

          <span className="theme3-logo-mark">
            ✦
          </span>

          <span className="theme3-logo-text">

            <span>
              SPICE
            </span>

            <span>
              FUSION
            </span>

          </span>

        </button>


        {/* =================================================
            DESKTOP / MOBILE NAVIGATION
        ================================================= */}

        <nav
          className={
            `theme3-navigation ${
              menuOpen
                ? "theme3-navigation-open"
                : ""
            }`
          }
        >

          {/* HOME */}

          <button
            type="button"
            onClick={goHome}
          >
            HOME
          </button>


          {/* OUR STORY */}

          <button
            type="button"
            onClick={() =>
              navigateToSection(
                "story"
              )
            }
          >
            OUR STORY
          </button>


          {/* MENU */}

          <button
            type="button"
            onClick={() =>
              navigateToSection(
                "menu"
              )
            }
          >
            MENU
          </button>


          {/* GALLERY */}

          <button
            type="button"
            onClick={() =>
              navigateToSection(
                "gallery"
              )
            }
          >
            GALLERY
          </button>


          {/* VISIT US */}

          <button
            type="button"
            onClick={() =>
              navigateToSection(
                "visit"
              )
            }
          >
            VISIT US
          </button>


          {/* CONTACT */}

          <button
            type="button"
            onClick={() =>
              navigateToSection(
                "contact"
              )
            }
          >
            CONTACT
          </button>

        </nav>


        {/* =================================================
            CART
        ================================================= */}

        <button
          type="button"
          className="theme3-cart-button"
          onClick={goCart}
          aria-label={`Open cart, ${cartCount} items`}
        >

          <span className="theme3-cart-icon">
            🛒
          </span>

          <span className="theme3-cart-text">
            CART
          </span>

          <span className="theme3-cart-count">
            {cartCount}
          </span>

        </button>


        {/* =================================================
            MOBILE MENU BUTTON
        ================================================= */}

        <button
          type="button"
          className={
            `theme3-mobile-menu-button ${
              menuOpen
                ? "theme3-mobile-menu-button-open"
                : ""
            }`
          }
          onClick={() =>
            setMenuOpen(
              (previous) =>
                !previous
            )
          }
          aria-label={
            menuOpen
              ? "Close navigation menu"
              : "Open navigation menu"
          }
          aria-expanded={menuOpen}
        >

          <span></span>
          <span></span>
          <span></span>

        </button>


      </div>

    </header>

  );

}


export default Header;